import handleUrlPdfPrint from "../../utils/handle-send-post-data";

const summary = () => {
  const init = () => {
    handleHeader();
  };

  const handleHeader = () => {
    const el = {
      printPdfUrl: ".js-print-url",
    };

    handleUrlPdfPrint(el.printPdfUrl);
  };

  init();
};

try {
  summary();
} catch (error) {
  console.error("summary", error);
}
